export default __webpack_public_path__ + "static/media/notification_update_icon.6f5a7bbf.svg";